import { Box, Card, CardContent, Typography } from "@mui/material";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import { ReactNode } from "react";
import Flex from "../../../Flex";

type DescType = {
  incDesc: boolean;
  cardDescription: string;
};

interface CardProps {
  imageGroupSrc: ReactNode;
  cardTitle: number;
  heading: string;
  description: DescType;
  cardHeight?: string | number;
  cardWidth?: string | number;
}

const DashBoardCard = ({
  imageGroupSrc,
  cardTitle,
  heading,
  description,
  cardHeight,
  cardWidth,
}: CardProps) => {
  return (
    <Card
      sx={{
        pl: 2,
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 3,
      }}
    >
      <Flex width={cardWidth} height={cardHeight} gap={1} alignItems={"center"}>
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          bgcolor={"secondary.light"}
          height={"5em"}
          width={"25%"}
          borderRadius={"50%"}
        >
          {imageGroupSrc}
        </Flex>
        <Box>
          <CardContent>
            <Typography variant="h6" color={"secondary.main"}>
              {cardTitle}
            </Typography>
            <Typography variant="h5">{heading}</Typography>
          </CardContent>
          <Box>
            <Flex gap={"0.4rem"} mb={2} color={"gray"}>
              {description.incDesc === true ? (
                <NorthEastIcon color="success" />
              ) : (
                <SouthEastIcon color="error" />
              )}
              <Typography fontSize={"14px"}>
                {description.cardDescription}
              </Typography>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </Card>
  );
};

export default DashBoardCard;
